import { AlertCircle, CheckCircle, CircleX } from 'lucide-react';
import { DefaultAlert, Separator } from 'twyne-new.ui';

export default function AuthAlert({ children, color, isOpen, iconSize }) {
  if (!isOpen) {
    return null
  }

  return <DefaultAlert
    titleProps={{ className: 'text-base' }}
    variant={color}
    className='pb-1 mt-4'
    title={<div className='flex items-center gap-2 '>
      <Icon color={color} size={iconSize} />
      <Separator orientation='vertical' className={`py-2 twy-border-${color}`} />
      <span className='text-left'>{children}</span>
    </div>}
    icon={false}
  />
}

const Icon = ({ color, size }) => {
  const icons = {
    danger: CircleX,
    success: CheckCircle,
    warning: AlertCircle,
  }

  const Icon = icons[color]
  return <Icon size={size || 16} />
}
